import React from 'react';
import MaterialGuardians from './MaterialGuardians';

export default class SpouseGuardians extends MaterialGuardians {
  static forSpouse = true;
}
